import React from 'react';
import { Result, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import Seo from '../../components/Seo';
import { PAGE_SEO, SITE_URL } from '../../utils/seo';

const { Title, Text } = Typography;

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    const goHome = () => {
        navigate('/');
    };

    return (
        <div style={{ textAlign: 'center', padding: '50px', backgroundColor: '#f0f2f5', marginTop: '10px' }}>
            <Seo
                title={PAGE_SEO.NOT_FOUND.title}
                description={PAGE_SEO.NOT_FOUND.description}
                canonical={`${SITE_URL}/404`}
                noindex
            />
            <Result
                status="404"
                title={
                    <Title level={1} style={{ fontSize: '64px', color: '#001529' }}>
                        404
                    </Title>
                }
                subTitle={
                    <Text type="secondary" style={{ fontSize: '20px' }}>
                        Sorry! The page you are looking for does not exist.
                    </Text>
                }
                extra={
                    <Button type="primary" size="large" onClick={goHome}>
                        Go Back Home
                    </Button>
                }
            />
        </div>
    );
};

export default NotFoundPage;
